import { useMediaQuery } from "@material-ui/core";

interface IBreakpoints {
  desktopMin?: number;
  mobileMax?: number;
  smallDesktopMin?: number;
  smallDesktopMax?: number;
  largeDesktopMin?: number;
  tabletMin?: number;
  tabletMax?: number;
}

interface IDeviceTypes {
  matchesDesktop: boolean;
  matchesSmallDesktop: boolean;
  matchesLargeDesktop: boolean;
  matchesMobile: boolean;
  matchesTablet: boolean;
}

export const useDeviceTypes = (
  breakpoints: IBreakpoints = {
    desktopMin: 961,
    mobileMax: 960,
    smallDesktopMin: 961,
    smallDesktopMax: 1014,
    largeDesktopMin: 1280,
    tabletMin: 768,
    tabletMax: 960,
  }
): IDeviceTypes => {
  const {
    desktopMin,
    mobileMax,
    smallDesktopMin,
    smallDesktopMax,
    largeDesktopMin,
    tabletMin,
    tabletMax,
  } = breakpoints;

  const options = {
    noSsr: true,
  };

  const matchesDesktop = useMediaQuery(`(min-width: ${desktopMin}px)`, options);
  const matchesMobile = useMediaQuery(`(max-width: ${mobileMax}px)`, options);
  const matchesSmallDesktop = useMediaQuery(
    `(min-width: ${smallDesktopMin}px) and (max-width: ${smallDesktopMax}px)`,
    options
  );
  const matchesLargeDesktop = useMediaQuery(
    `(min-width: ${largeDesktopMin}px)`,
    options
  );
  const matchesTablet = useMediaQuery(
    `(min-width: ${tabletMin}px) and (max-width: ${tabletMax}px)`,
    options
  );

  return {
    matchesDesktop,
    matchesMobile,
    matchesSmallDesktop,
    matchesLargeDesktop,
    matchesTablet,
  };
};
